import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Pagination,
  Navigation,
  Scrollbar,
  A11y,
} from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useMobileDetect } from "@/hooks";
import { renderCarouselIcons } from "@/components/customCarousel";
import { getCdnUrl } from "@/lib/utils";
interface CardProps {
  title: string;
  imgUrl: string;
}

const Card = ({ title, imgUrl }: CardProps) => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-between rounded-xl bg-card-gradient p-4 xl:h-[302px] xl:w-[287px]">
      <div className="z-10 flex w-full items-center justify-center">
        <img className="h-[7rem] lg:h-[12rem]" src={imgUrl} alt="slide" />
      </div>
      <div className="items flex flex-col items-center">
        <div className="text-xl font-semibold text-white md:text-2xl">
          {title}
        </div>
      </div>
    </div>
  );
};

const OurGame = () => {
  const isMobile = useMobileDetect();

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="w-full">
        <Swiper
          slidesPerView={isMobile ? 2 : 4}
          className="lg:pb-0"
          style={{
            paddingBottom: isMobile ? "32px" : 0,
          }}
          centeredSlides={false}
          modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
          freeMode={true}
          loop={true}
          autoHeight
          pagination={{
            clickable: true,
            type: "custom",
            renderCustom: renderCarouselIcons,
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          speed={1300}
          spaceBetween={16}
        >
          <SwiperSlide key="crash">
            <Link to="/casino/lobby?tab=battles">
              <Card
                title="Crash Games"
                imgUrl={getCdnUrl("assets/lander/crash-lander.png")}
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide key="slots">
            <Link to="/casino/lobby?tab=slots">
              <Card
                title="Slots"
                imgUrl={getCdnUrl("assets/lander/slots-lander.png")}
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide key="live">
            <Link to="/casino/lobby?tab=liveCasino">
              <Card
                title="Live Dealer"
                imgUrl={getCdnUrl("assets/lander/live-lander.png")}
              />
            </Link>
          </SwiperSlide>
          <SwiperSlide key="table">
            <Link to="/casino/lobby?tab=sidebets">
              <Card
                title="Table Game"
                imgUrl={getCdnUrl("assets/lander/table-lander.png")}
              />
            </Link>
          </SwiperSlide>
        </Swiper>
      </div>
      <EarnComponent />
    </div>
  );
};

const EarnComponent = () => (
  <div className="grid h-full grid-cols-3 gap-2 lg:gap-4">
    <Link to="/bonuses">
      <EarnSmallCard
        title="Bonus"
        imageUrl={getCdnUrl("assets/home/bonus.png")}
        alt="bonus"
        className="bg-gradient-to-tl from-[#B969FF]/50 to-[#001E69]/50"
        imageClassName="scale-[1.6] translate-x-3 translate-y-4 lg:translate-x-7 lg:translate-y-4 lg:scale-[1.2]"
      />
    </Link>
    <Link to="/bonuses?tab=dailyBonus">
      <EarnSmallCard
        title="Rewards"
        imageUrl={getCdnUrl("assets/home/rewards.png")}
        alt="rewards"
        className="bg-gradient-to-br from-[#001E69]/50 to-[#FFAE00]/50"
        imageClassName="scale-[1.6] translate-x-3 translate-y-2 lg:translate-x-7 lg:translate-y-2 lg:scale-[1.2]"
      />
    </Link>
    <Link to="/rakeback-system">
      <EarnSmallCard
        title="Ranking"
        imageUrl={getCdnUrl("assets/home/ranking.png")}
        alt="rankings"
        className="bg-gradient-to-br from-[#001E69]/50 to-[#1BFFFF]/50"
        imageClassName="scale-[1.6] translate-y-8 lg:translate-y-5 lg:translate-y-8 lg:scale-[1]"
      />
    </Link>
  </div>
);

const EarnSmallCard = ({
  title,
  imageUrl,
  alt,
  className,
  imageClassName,
}: {
  title: string;
  imageUrl: string;
  alt: string;
  className?: string;
  imageClassName?: string;
}) => (
  <div
    className={`flex flex-col items-center items-center justify-between overflow-hidden rounded-lg p-4 ${className} h-full w-[full] gap-6 lg:h-[300px] lg:w-[387px] lg:gap-4`}
  >
    <img
      src={imageUrl}
      alt={alt}
      className={`w-[8rem] rounded-lg ${imageClassName} lg:w-[14rem]`}
    />
    <h3 className="text-xl font-[500] text-white lg:text-2xl lg:font-bold">
      {title}
    </h3>
  </div>
);

export default OurGame;
